function generateIdFromProducto(producto) {
    return `${producto.nombre}-${producto.categoria}`
      .toLowerCase()
      .replace(/\s+/g, '-')       
      .replace(/[^a-z0-9-]/g, ''); 
  }
  
function limpiarTextoParaSlug(texto) {
return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") 
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') 
    .replace(/[^a-z0-9-]/g, ''); 
}

const productosPriveCollection = [
    {
        nombre: 'Venus',
        categoria: 'Dim out',
        colores: ['Silver', 'Basalto', 'Onix', 'Lava'],
        anchoTela: '3.00',
        sistema: 'Sheer Elegance',
        caracteristica: 'Maya color Negro',
        textura: 'Textura & patrón horizontal',
        descripcionExtra: 'Textura profunda. Comportamiento lumínico controlado.',
        images: [
            require('../../assets/img/productos/priveCollection/venus/muestra.png'),
            require('../../assets/img/productos/priveCollection/venus/1.jpg'), 
            require('../../assets/img/productos/priveCollection/venus/2.jpg'), 
            require('../../assets/img/productos/priveCollection/venus/3.jpg'), 
            require('../../assets/img/productos/priveCollection/venus/4.jpg')
        ]
    },
    {
        nombre: 'Lumiere',
        categoria: 'Dim out',
        colores: ['Nacar', 'Iron', 'Quarzo', 'Graphite', 'Carbon'],
        anchoTela: '3.00',
        sistema: 'Sheer Elegance',
        caracteristica: 'Maya color Negro',
        textura: 'Textura & patrón horizontal',
        descripcionExtra: 'Brillo controlado. Paleta extensa. Caída impecable.',
        images: [
            require('../../assets/img/productos/priveCollection/lumiere/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/lumiere/1.jpg'), 
            require('../../assets/img/productos/priveCollection/lumiere/2.jpg'), 
            require('../../assets/img/productos/priveCollection/lumiere/3.jpg'), 
            require('../../assets/img/productos/priveCollection/lumiere/4.jpg'),
            require('../../assets/img/productos/priveCollection/lumiere/5.jpg')
        ]
    },
    {
        nombre: 'Aria',
        categoria: 'Dim out',
        colores: ['White', 'Sand', 'Taupe', 'Dark Grey'],
        anchoTela: '2.80',
        sistema: 'Sheer Elegance Dim out',
        caracteristica: 'Maya color Negro',
        textura: 'Textura & patrón horizontal',
        descripcionExtra: 'Control de luz sin bloqueo total.',
        images: [
            require('../../assets/img/productos/priveCollection/aria/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/aria/1.jpg'), 
            require('../../assets/img/productos/priveCollection/aria/2.jpg'), 
            require('../../assets/img/productos/priveCollection/aria/3.jpg'), 
            require('../../assets/img/productos/priveCollection/aria/4.jpg')
        ]
    },
    {
        nombre: 'Solar Linen',
        categoria: 'Filtro Ligero',
        colores: ['Marfil', 'Bone', 'Taupe', 'Ash', 'Blender'],
        anchoTela: '3.00',
        sistema: 'Screen Enrollable',
        caracteristica: 'Filtro Solar Traslucido',
        textura: 'Textura & patrón uniforme',
        descripcionExtra: 'Calidez orgánica. Difusión de luz natural.',
        images: [
            require('../../assets/img/productos/priveCollection/solarLinen/1.jpg'), 
            require('../../assets/img/productos/priveCollection/solarLinen/1.jpg'), 
            require('../../assets/img/productos/priveCollection/solarLinen/2.jpg'), 
            require('../../assets/img/productos/priveCollection/solarLinen/3.jpg'), 
            require('../../assets/img/productos/priveCollection/solarLinen/4.jpg'),
            require('../../assets/img/productos/priveCollection/solarLinen/5.jpg')
        ]
    },
    {
        nombre: 'FL Wheat',
        categoria: 'Filtro Ligero',
        colores: ['Lava', 'Basalto', 'Silver', 'Grey'],
        anchoTela: '2.80',
        sistema: 'Enrollable',
        caracteristica: 'Tela Traslucida',
        textura: 'Textura & patrón Uniforme',
        descripcionExtra: 'Brillo controlado. Paleta extensa. Caída impecable. Gestión de Luz Natural con elegancia.',
        images: [
            require('../../assets/img/productos/priveCollection/flWheat/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/flWheat/1.jpg'), 
            require('../../assets/img/productos/priveCollection/flWheat/2.jpg'), 
            require('../../assets/img/productos/priveCollection/flWheat/3.jpg'), 
            require('../../assets/img/productos/priveCollection/flWheat/4.jpg')
        ]
    },
    {
        nombre: 'FL Shantung',
        categoria: 'Filtro Ligero',
        colores: ['White', 'Ivory', 'Steel', 'Latte'],
        anchoTela: '3.00',
        sistema: 'Enrollable',
        caracteristica: 'Tela Traslucida',
        textura: 'Textura & patrón horizontal',
        descripcionExtra: 'Brillo controlado. Paleta extensa. Caída impecable.',
        images: [
            require('../../assets/img/productos/priveCollection/flShantung/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/flShantung/1.jpg'), 
            require('../../assets/img/productos/priveCollection/flShantung/2.jpg'), 
            require('../../assets/img/productos/priveCollection/flShantung/3.jpg'), 
            require('../../assets/img/productos/priveCollection/flShantung/4.jpg')
        ]
    },
    {
        nombre: 'FL Dallas',
        categoria: 'Filtro Ligero',
        colores: ['Artic White', 'Oyster', 'Almond', 'Harbor'],
        anchoTela: '3.00',
        sistema: 'Enrollable',
        caracteristica: 'Tela Traslucida',
        textura: 'Textura & patrón horizontal',
        descripcionExtra: 'Brillo controlado. Paleta extensa. Caída impecable.',
        images: [
            require('../../assets/img/productos/priveCollection/dallas/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/dallas/1.jpg'), 
            require('../../assets/img/productos/priveCollection/dallas/2.jpg'), 
            require('../../assets/img/productos/priveCollection/dallas/3.jpg'), 
            require('../../assets/img/productos/priveCollection/dallas/4.jpg')
        ]
    },
    {
        nombre: 'FL Clearview',
        categoria: 'Filtro Ligero',
        colores: ['White', 'Latte', 'Ivory', 'Grey'],
        anchoTela: '2.80',
        sistema: 'Enrollable',
        caracteristica: 'Tela Traslucida',
        textura: 'Textura & patrón Uniforme',
        descripcionExtra: 'Brillo controlado. Paleta extensa. Caída impecable.',
        images: [
            require('../../assets/img/productos/priveCollection/flClearview/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/flClearview/1.jpg'), 
            require('../../assets/img/productos/priveCollection/flClearview/2.jpg'), 
            require('../../assets/img/productos/priveCollection/flClearview/3.jpg'), 
            require('../../assets/img/productos/priveCollection/flClearview/4.jpg')
        ]
    },
    {
        nombre: 'BO Shantung',
        categoria: 'Blackout',
        colores: ['Bone', 'Silver', 'Plomo', 'Camel', 'Fosil'],
        anchoTela: '3.00',
        sistema: 'Enrollable',
        caracteristica: 'Control Térmico',
        textura: 'Protección UV',
        descripcionExtra: 'Privacidad total con cara interior decorativa.',
        images: [
            require('../../assets/img/productos/priveCollection/boShantung/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/boShantung/1.jpg'), 
            require('../../assets/img/productos/priveCollection/boShantung/2.jpg'), 
            require('../../assets/img/productos/priveCollection/boShantung/3.jpg'), 
            require('../../assets/img/productos/priveCollection/boShantung/4.jpg'),
            require('../../assets/img/productos/priveCollection/boShantung/5.jpg')
        ]
    },
    {
        nombre: 'BO Dallas',
        categoria: 'Blackout',
        colores: ['Pale', 'Greige', 'Stone', 'Pewter'],
        anchoTela: '3.00',
        sistema: 'Enrollable',
        caracteristica: 'Control Térmico',
        textura: 'Protección UV',
        descripcionExtra: 'Privacidad total con cara interior decorativa.',
        images: [
            require('../../assets/img/productos/priveCollection/boDallas/muestra.jpg'),
            require('../../assets/img/productos/priveCollection/boDallas/1.jpg'), 
            require('../../assets/img/productos/priveCollection/boDallas/2.jpg'), 
            require('../../assets/img/productos/priveCollection/boDallas/3.jpg'), 
            require('../../assets/img/productos/priveCollection/boDallas/4.jpg')
        ]
    }
].map(producto => ({
    ...producto,
    id: generateIdFromProducto(producto),
    slug: limpiarTextoParaSlug(`${producto.nombre}-${producto.categoria}`),
    categoriaSlug: limpiarTextoParaSlug(producto.categoria)
  }));

export default productosPriveCollection;